/**
 * How many leave guards (unsaved edits, one-time secrets) are active right
 * now. Code that would reload the page on its own (e.g. after a deploy) checks
 * this and leaves the decision to the user instead.
 */
let active = 0;

export function holdLeaveGuard(): () => void {
  active += 1;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    active -= 1;
  };
}

export function leaveGuardActive(): boolean {
  return active > 0;
}
